import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useGetDashboardCardBoardPieCricleData } from 'features/dashboard/use-cases/get-dashboard-cricle';
import { Fragment } from 'react/jsx-runtime';
import { Spin } from 'antd';
import { useEffect, useRef } from 'react';
import { useUserContext } from 'features/users';

export const RegistrationbookedtypeView = ({ dateRange, selectedYear, selectedEvent, selectedCategory }: any) => {
  const { user } = useUserContext()
  const { data: bookingtypeData, isLoading } = useGetDashboardCardBoardPieCricleData({
    Flag: "bookingtype",
    FromDate: dateRange?.[0]?.format("YYYY-MM-DD") || "",
    ToDate: dateRange?.[1]?.format("YYYY-MM-DD") || "",
    Year: selectedYear || "",
    EventId: selectedEvent || "",
    CategoryId: selectedCategory || "",
    AgentId: user?.user_id
  });

  const chartRef = useRef<HighchartsReact.RefObject>(null);
  const bookingType = bookingtypeData?.BookingType || {};

  const individualCount = bookingType?.UniqueInvoiceCount || 0;
  const groupCount = bookingType?.GroupedInvoiceCount || 0;
  const hasData = individualCount > 0 || groupCount > 0;

  const options: Highcharts.Options = {
    chart: {
      type: 'pie',
    },
    title: {
      text: 'Booking Type Distribution',
    },
    lang: {
      noData: "No data found",
    },
    noData: {
      style: {
        fontSize: "14px",
        color: "#666",
      },
    },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b>',
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
      },
    },
    credits: {
      enabled: false,
    },
    colors: ['#ffc107', '#000000'], // Yellow = Individual, Black = Group
    series: hasData
      ? [
        {
          name: 'Bookings',
          type: 'pie',
          data: [
            { name: 'Individual', y: individualCount },
            { name: 'Group', y: groupCount },
          ],
        },
      ]
      : [], // 🔹 empty dataset triggers "No data found"
  };

  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (chart) {
      if (isLoading) {
        chart.showLoading("Loading data...");
      } else {
        chart.hideLoading();
      }
    }
  }, [isLoading]);

  return (
    <Fragment>
      <Spin spinning={isLoading}>
        <HighchartsReact ref={chartRef} highcharts={Highcharts} options={options} />
      </Spin>
    </Fragment>
  );
};
